import { MorphGene } from "../types/Morph.ts";
import { Gene, isChanceGene } from "../types/Gene.ts";


function getGenotype(input: { isHet: boolean, gene_type: string, gene_name: string }) {
    let genotype = "Homozygous";
    if (input.isHet) {
        if (input.gene_type === "Recessive") {
            genotype = "Het";
        }
    } else {
        if (input.gene_type !== "Recessive") {
            genotype = "Het";
        }
    }
    return genotype;
}

const lineBredLabel = "(Line Bred)";
const unprovenLabel = "(Unproven)";
export const GeneCalculator = ({ maleInput, femaleInput, morphs }) => {
    var maleGenes = {}, femaleGenes = {};
    let hasLinebred = maleInput.some(gene => gene.gene_type === lineBredLabel) || femaleInput.some(gene => gene.gene_type === lineBredLabel);
    let hasUnproven = maleInput.some(gene => gene.gene_type === unprovenLabel) || femaleInput.some(gene => gene.gene_type === unprovenLabel);
    for (let i = 0; i < maleInput.length; i++) {
        if (maleInput[i].gene_type === lineBredLabel || maleInput[i].gene_type === unprovenLabel) {
            continue
        }
        const geneName = maleInput[i].gene_name;

        maleGenes[geneName] = {
            geneType: maleInput[i].gene_type,
            genotype: getGenotype(maleInput[i]),
            geneName,
        }
    }
    for (let j = 0; j < femaleInput.length; j++) {
        if (femaleInput[j].gene_type === lineBredLabel || femaleInput[j].gene_type === unprovenLabel) {
            continue
        }
        const geneName = femaleInput[j].gene_name;
        femaleGenes[geneName] = {
            geneType: femaleInput[j].gene_type,
            genotype: getGenotype(femaleInput[j]),
            geneName
        }
    }

    var permutations = {};
    var absolutes = {};
    var allGenes = {};
    var extraOccurances = [];
    Object.keys(maleGenes).forEach(gene => {
        allGenes[gene] = maleGenes[gene];
    })

    Object.keys(femaleGenes).forEach(gene => {
        var geneInfo = femaleGenes[gene].geneType;
        if (!allGenes[gene]) {
            if ((geneInfo.localeCompare("Codom") === 0 || geneInfo.localeCompare("Dominant") === 0)) {
                if (femaleGenes[gene].genotype === "Homozygous") {
                    permutations[gene] = [gene];
                } else {
                    permutations[gene] = [gene, ""];
                }
            } else if (geneInfo.localeCompare("Rec") === 0 || geneInfo.localeCompare("Recessive") === 0) {
                if (femaleGenes[gene].genotype === "Homozygous") {
                    permutations[gene] = ["het " + gene];
                } else {
                    permutations[gene] = ["het " + gene, ""];
                }
            }
        } else {
            if (femaleGenes[gene].genotype === "Homozygous" && allGenes[gene].genotype === "Homozygous") {
                absolutes[gene] = [allGenes[gene].geneName];
                permutations[gene] = [allGenes[gene].geneName];
            } else if (
                (femaleGenes[gene].genotype !== "Homozygous" && allGenes[gene].genotype === "Homozygous")
                || (femaleGenes[gene].genotype === "Homozygous" && allGenes[gene].genotype !== "Homozygous")) {
                if (geneInfo.localeCompare("Codom") === 0 || geneInfo.localeCompare("Dominant") === 0) {
                    permutations[gene] = [gene + " (Homozygous)", gene];
                } else if (geneInfo.localeCompare("Rec") === 0 || geneInfo.localeCompare("Recessive") === 0) {
                    permutations[gene] = [gene, "het " + gene];

                }

            } else {
                if (geneInfo.localeCompare("Codom") === 0 || geneInfo.localeCompare("Dominant") === 0) {
                    permutations[gene] = [gene + " (Homozygous)", gene, ""];
                    extraOccurances.push({ name: gene, isHet: false });
                } else if (geneInfo.localeCompare("Rec") === 0 || geneInfo.localeCompare("Recessive") === 0) {
                    permutations[gene] = [gene, "het " + gene, ""];
                    extraOccurances.push({ name: gene, isHet: true });
                }
            }
        }
    })
    Object.keys(maleGenes).forEach(gene => {
        var geneInfo = maleGenes[gene].geneType;
        if (!permutations[gene] && !absolutes[gene]) {
            if ((geneInfo.localeCompare("Codom") === 0 || geneInfo.localeCompare("Dominant") === 0)) {
                if (maleGenes[gene].genotype === "Homozygous") {
                    permutations[gene] = [gene];
                } else {
                    permutations[gene] = [gene, ""];
                }
            } else if (geneInfo.localeCompare("Rec") === 0 || geneInfo.localeCompare("Recessive") === 0) {
                if (maleGenes[gene].genotype === "Homozygous") {
                    permutations[gene] = ["het " + gene];
                } else {
                    permutations[gene] = ["het " + gene, ""];
                }
            }
        } else {
            if ((geneInfo.localeCompare("Codom") === 0 || geneInfo.localeCompare("Dominant") === 0)) {
                if (maleGenes[gene].genotype === "Homozygous" && femaleGenes[gene].genotype === "Homozygous") {
                    permutations[gene] = [`${gene} (Homozygous)`];
                } else if (maleGenes[gene].genotype === "Homozygous") {
                    permutations[gene] = [`${gene} (Homozygous)`, gene];
                } else {
                    permutations[gene] = [`${gene} (Homozygous)`, gene, ""];
                }
            } else if ((geneInfo.localeCompare("Rec") === 0 || geneInfo.localeCompare("Recessive") === 0) && !permutations[gene]) {
                if (maleGenes[gene].genotype === "Het" && femaleGenes[gene].genotype === "Het") {
                    permutations[gene] = ['', `het ${gene}`, gene];
                } else if (maleGenes[gene].genotype === "Het") {
                    permutations[gene] = [`het ${gene}`, gene];
                } else {
                    permutations[gene] = [gene];
                }
            }
        }
    })
    if (Object.keys(permutations).length > 1) {
        delete permutations["Wild Type"];
    }
    if (Object.keys(permutations).length === 0) {
        permutations["Wild Type"] = ["Wild Type"];
    }
    var tmpArray: string[] = [];
    var size = 0;
    Object.keys(permutations).forEach(gene => {
        tmpArray.push(permutations[gene]);
        size += permutations[gene].length - 1;
    })
    var size = Math.pow(2, size);
    var results = getAllResults(tmpArray);
    if (!results) {
        alert("There was a problem calculating pairings. Please check your input and try again.")
        return
    }
    var sortedResults = sortAllResults(results);
    var finalResults = getFinalResults(sortedResults, morphs);
    for (var x = 0; x < finalResults.length; x++) {
        finalResults[x].multiplier = 1;
        for (var y = 0; y < extraOccurances.length; y++) {
            var occurance = extraOccurances[y];
            for (var z = 0; z < finalResults[x].geneList.length; z++) {
                var gene = finalResults[x].geneList[z];
                var geneName = gene.name;
                if (geneName.indexOf("het ") !== -1) {
                    geneName = geneName.substring(4);
                }
                if (occurance.isHet === gene.isHet && occurance.name === geneName) {
                    finalResults[x].multiplier *= 2;
                }
            }
        }
    }
    finalResults = sortAlphabetically(finalResults);
    return { results: finalResults, hasLinebred, hasUnproven };
    //showResults(finalResults, size);

}

export const makeMorphNameString = (selectedGenes, morphs, usedInCalculation = true) => {
    const suffixedGenes = selectedGenes.map((gene) => {
        if ((gene.isHet || gene.expression === "SUPER") && (gene.gene_type === "Dominant" || gene.gene_type === "Codom" || gene.gene_type === "Dom")) {
            return { ...gene, gene_name: `${gene.gene_name} (Homozygous)` }
        }
        return gene;
    })
    const hetGenes = suffixedGenes.filter((gene) => {
        if (gene.isHet || gene.expression === "HET") {
            if (gene.gene_type === "Recessive") {
                return true
            }
        }
        return false;
    })
    const homGenes = suffixedGenes.filter((gene) => {
        if (gene.gene_name === "Wild Type" && suffixedGenes.length > 1) {
            return false;
        }
        if (!gene.isHet) {
            if (gene.gene_type === "Recessive" && gene.expression === "NORMAL") {
                return true;
            }
        }
        if (gene.isHet && gene.gene_type !== "Recessive") {
            return true
        }
        if (gene.gene_type === "Dominant" || gene.gene_type === "Codom" || gene.gene_type === "Dom") {
            return true
        }
        if (!usedInCalculation && (gene.gene_type === "(Unproven)" || gene.gene_type === "(Line Bred)")) {
            return true
        }
        return false
    })
    let homs = homGenes.map((gene) => gene.gene_name);
    const hets = hetGenes.map((gene) => gene.gene_name);

    return getFinalResults([{ homs, hets }], morphs)[0];
}

export const makeMorphNameStringPotential = (selectedGenes, morphs) => {
    let filteredGenes = selectedGenes.filter(gene => !isChanceGene(gene) && gene.gene_name !== "");

    let result = makeMorphNameString(filteredGenes, morphs, false)
    const hetGenes = selectedGenes.filter(gene => isChanceGene(gene));
    const resultHets = result.hets;
    const definiteHets = hetGenes.filter(gene => gene.expression === "HET").map(gene => gene.gene_name && !resultHets.includes(gene.gene_name) ? gene.gene_name : null);
    const potentialHets = hetGenes.filter(gene => gene.expression === "POSSIBLE_HET").map(gene => gene.gene_name);
    const fiftyPercentHets = hetGenes.filter(gene => gene.expression === "FIFTY_PERCENT").map(gene => gene.gene_name);
    const sixtySixPercentHets = hetGenes.filter(gene => gene.expression === "SIXTY_SIX_PERCENT").map(gene => gene.gene_name);

    let hetString = '';
    hetString += resultHets.length ? ' het ' + resultHets.join(', ') : '';
    hetString += definiteHets.length ? ' het ' + definiteHets.join(', ') : '';
    hetString += sixtySixPercentHets.length ? ' 66% het ' + sixtySixPercentHets.join(', ') : '';
    hetString += fiftyPercentHets.length ? ' 50% het ' + fiftyPercentHets.join(', ') : '';
    hetString += potentialHets.length ? ' possible het ' + potentialHets.join(',') : '';

    result.finalResults += hetString;

    return result.finalResults || "Normal";
}


export const mapMorphGenesToGeneList = (morphGenes: MorphGene[]) => {
    return morphGenes.map((gene) => {
        return {
            ...gene,
            genotype: getGenotype(gene),
            gene_name: gene.gene_name.replace(" (Homozygous)", "").replace("Wild Type", ""),
            isHet: gene.gene_name.includes("(Homozygous)") || gene.is_super === true
        }
    });
}

export function geneStringSearch(spaceDelimitedString: string, genes: Gene[]) {
    const calcGeneArray = [];
    const splitName = spaceDelimitedString.split(' ');
    let searchName = '';
    for (let x = 0; x < splitName.length; x++) {
        if (searchName !== '') {
            searchName += ' ';
        }
        searchName += splitName[x];
        const findGene = genes.find(gene => gene.gene_name === searchName);
        if (findGene) {
            searchName = '';
            calcGeneArray.push({
                ...findGene,
                genotype: getGenotype(findGene),
                gene_type: findGene.gene_type,
                isHet: spaceDelimitedString.includes("(Homozygous)") || findGene.is_super === true,
            })
        }
    }

    return calcGeneArray;
}

function getAllResults(arr) {
    if (arr.length === 0) {
        return;
    }
    if (arr.length === 1) {
        return arr[0];
    } else {
        var result = [];
        var allCasesOfRest = getAllResults(arr.slice(1));  // recur with the rest of array
        for (var i = 0; i < allCasesOfRest.length; i++) {
            for (var j = 0; j < arr[0].length; j++) {
                result.push(arr[0][j] + ", " + allCasesOfRest[i]);
            }
        }
        return result;
    }

}

function sortAllResults(results: string[]) {
    var sortedResults = [];
    for (var x = 0; x < results.length; x++) {
        var result = results[x].split(",");
        var sortResult = { homs: [], hets: [], geneList: [] };
        for (var y = 0; y < result.length; y++) {
            var name = result[y].charAt(0) === " " ? result[y].substring(1) : result[y];
            if (result[y].match("het")) {
                sortResult.hets.push(result[y].substring(4));
                sortResult.geneList.push({ name, isHet: true })
            } else if (result[y] !== "" && result[y] !== " ") {
                sortResult.homs.push(name);
                sortResult.geneList.push({ name, isHet: false })
            }
        }
        if (sortResult.homs[0] === "" || sortResult.homs.length < 1) {
            sortResult.homs[0] = "Wild Type";
        }
        sortedResults.push(sortResult);
    }

    return sortedResults;
}
function sortAlphabetically(results) {
    return results.sort((a, b) => {
        var nameA = a.finalResults.toUpperCase();
        var nameB = b.finalResults.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // names must be equal
        return 0;
    });
}
const contains = (array, variable) => {
    for (var x = 0; x < array.length; x++) {
        if (array[x].localeCompare(variable) === 0) {
            return true;
        }
    }
    return false;
}

export function getFinalResults(results, morphs) {

    if (results.length === 1 && results[0] === "") {
        return [];
    }

    for (var x = 0; x < results.length; x++) {
        results[x].finalResults = "";
        var geneArray = results[x].homs;
        var currentMatchCount = 0;
        var bestMatchCount = 0;
        var bestMatch = "";
        var match = false;
        var extra = [];
        var matched = [];
        var homExtra = geneArray.slice();
        for (var y = 0; y < morphs.length; y++) {
            var listofGenes = morphs[y];
            var traits = listofGenes.genes;

            currentMatchCount = 0;
            extra = [];
            homExtra = geneArray.slice();
            //   extra = geneArray.slice();
            matched = [];


            // TODO: Added after release possible fix to slow loading times
            if (traits.length > geneArray.length) {
                continue;
            }

            for (var singleMorphTrait = 0; singleMorphTrait < traits.length; singleMorphTrait++) { // Morph from list
                for (var xz = 0; xz < geneArray.length; xz++) { // morph combo from parameter

                    var trait = traits[singleMorphTrait].gene_name;
                    if (traits[singleMorphTrait] === undefined) {
                        continue;
                    }
                    if (trait.includes("(Unproven)")) {
                        trait = trait.substring(0, trait.length - 11);
                    }
                    if (traits[singleMorphTrait].is_super) {
                        trait = trait + " (Homozygous)";
                    }
                    if (geneArray[xz] === trait) {
                        currentMatchCount++;
                        if (extra.indexOf(geneArray[xz]) !== -1) {
                            extra.splice(extra.indexOf(geneArray[xz]), 1);
                        }
                        if (homExtra.indexOf(geneArray[xz]) !== -1) {
                            homExtra.splice(homExtra.indexOf(geneArray[xz]), 1);
                        }
                        matched.push(geneArray[xz]);
                    }
                    else if (!contains(extra, geneArray[xz]) && !contains(matched, geneArray[xz])) {
                        if (geneArray[xz].includes("(Het)")) {
                            extra.push(geneArray[xz]);
                        }
                    }
                }

                // TODO: if exactly perfect match break out of 2 for loops
                if (currentMatchCount > bestMatchCount && currentMatchCount >= traits.length) {
                    bestMatchCount = currentMatchCount;
                    bestMatch = listofGenes.name;
                    match = true;
                    for (let yz = 0; yz < homExtra.length; yz++) {
                        if (homExtra[yz] !== " ") {
                            bestMatch = homExtra[yz] + " " + bestMatch;
                        }
                    }
                    if (extra.length > 0) {
                        for (let zi = 0; zi < extra.length; zi++) {
                            if (!contains(matched, extra[zi])) {
                                bestMatch += "," + extra[zi];
                            }
                        }
                    }

                }
            }

        }
        if (match) {
            results[x].finalResults = bestMatch;
            bestMatch = "";
        }
    }
    return results;
}
export function showResults(results, size) {

    // size = Math.pow(2, app.hets);
    var pics = [];

    for (var x = 0; x < results.length; x++) {

        var full = "";
        //  if (fullName[x].morphName.localeCompare("Wild Type")) {
        var multiplier = 1;
        if (results[x].multiplier !== null) {
            multiplier = results[x].multiplier;
        }

        full = results[x].finalResults;
        pics.push(results[x].finalResults);
        if (full === "") {
            for (var y = 0; y < results[x].homs.length; y++) {
                full += results[x].homs[y] + " ";
            }
        }
        for (var y = 0; y < results[x].hets.length; y++) {
            if (y === 0) {
                full += " het ";
            } else {
                full += ", "
            }
            full += results[x].hets[y];
        }
    }

}
function reduce(numerator, denominator) {

    var gcd = function gcd(a, b) {
        return b ? gcd(b, a % b) : a;
    };
    gcd = gcd(numerator, denominator);
    return [numerator / gcd, denominator / gcd];

}